import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TypeEnum } from '../../../../../models/template/type.enum';
import { metaCarouselBlocksForSelect } from '../../../../../utils/blocks-helper';
import { TemplateEditorComponent } from '../../../base-template-editor/template-editor.component';
import { BlockMaximumCount } from '../../../../../models/template/block-maximum-count.interface.';
import { BlockMinimumCount } from '../../../../../models/template/block-minimum-count.interface';
import { RequiredFieldConstraint } from '../../../../../models/template/required-field-constraint.interface';

const EMPTY_CARD = { Headline: '', Link: '', Format: 'Image', Media: '' };

@Component({
    selector: 'app-meta-carousel-template',
    imports: [TemplateEditorComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
    <app-template-editor
      [templateType]="templateType"
      templateBasePath="/meta-carousel-template/"
      channelLabel="Meta Carousel Ad"
      namePlaceholder="Enter Meta Carousel Ad template name"
      emptyMessage="No Meta Carousel Ad found!"
      heartbeatType="meta-carousel-template"
      [enableBlockToolbar]="true"
      [showSidePreview]="true"
      [blockCatalog]="blockCatalog"
      [subscribeToMedia]="true"
      [defaultBlocks]="defaultBlocks"
      [blockMaximumCount]="blockMaximumCount"
      [blockMinimumCount]="blockMinimumCount"
      [requiredFields]="requiredFields"
      />
  `
})
export class MetaCarouselTemplateComponent {
  protected readonly templateType = TypeEnum.META_CAROUSEL;
  protected readonly blockCatalog = metaCarouselBlocksForSelect;

  // A carousel needs 2 to 10 cards.
  protected readonly blockMaximumCount: BlockMaximumCount[] = [
    { blockName: 'meta-carousel-card', limit: 10 },
  ];

  protected readonly blockMinimumCount: BlockMinimumCount[] = [
    { blockName: 'meta-carousel-card', treshold: 2 },
  ];

  // The card uploads and the dropdowns render no text editor, so the empty-field
  // check on save cannot see them — they are required explicitly.
  protected readonly requiredFields: RequiredFieldConstraint[] = [
    { blockName: 'meta-carousel-cta-text', field: 'Text', label: 'CTA' },
    { blockName: 'meta-carousel-account-type', field: 'AccountType', label: 'Account type' },
    { blockName: 'meta-carousel-card', field: 'Media', label: 'Card image or video' },
  ];

  // Order matters — it is the order the blocks are laid out in the editor.
  // Cards go last: one added from the block dropdown is pushed to the end.
  protected readonly defaultBlocks: { name: string; count?: number; variables: Record<string, string> }[] = [
    { name: 'meta-carousel-primary-text', count: 1, variables: { PrimaryText: '' } },
    { name: 'meta-carousel-cta-text', count: 1, variables: { Text: '' } },
    { name: 'meta-carousel-account-type', count: 1, variables: { AccountType: '' } },
    { name: 'meta-carousel-card', count: 1, variables: { ...EMPTY_CARD } },
    { name: 'meta-carousel-card', count: 2, variables: { ...EMPTY_CARD } },
  ];
}
